const browserDetection = () => {
    const userAgent = window.navigator.userAgent;

    // IE 10 or older
    const msie = userAgent.indexOf('MSIE');
    // IE 11
    const trident = userAgent.indexOf('Trident/');

    if (msie > 0 || trident > 0) {
        document.querySelector('.g-Body').classList.add('ie');
    }
}

browserDetection();